import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect, useContext } from 'react'
import { contains, indexOf, isEmpty } from 'underscore';
import { Context } from '../../..';
import UserService from '../../../services/UserService';

interface ItemProps {
    item: {
        id: number,
        organization: string;
    },
    selected: [],
    setSelected: (value: any[]) => void
};

const Item = (props: ItemProps) => {
    const { item, selected, setSelected } = props;
    const { id, organization } = item;
    const checked = contains(selected, id);

    const onChange = () => {
        const sel: any[] = selected.slice();
        if (contains(sel, id)) {
            sel.splice(indexOf(sel, id), 1)
        } else {
            sel.push(id);
        };
        setSelected(sel);
    };

    return (
        <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={checked} id={`item${id}`} name="item" onChange={() => onChange()} />
            <label className="form-check-label" htmlFor={`item${id}`}>{organization}</label>
        </div>
    );
};

export const OrganizationModal: FC = () => {
    const { store } = useContext(Context);
    const [query, setQuery] = useState('');
    const [newOrg, setNewOrg] = useState('');
    const [organizations, setOrganizations] = useState<[]>([]);
    const [popov, setPopov] = useState<boolean>(false);
    const [orgTitle, setOrgTitle] = useState<string[]>([]);
    const [selected, setSelected] = useState<any>(store.specInfo?.organizations || []);
    const [orgPopover, setOrgPopover] = useState<boolean>(false);

    const getOrganizations = async () => {
        const res = await UserService.getOrganizations(query);
        setOrganizations(res.data.results);
    };

    useEffect(() => {
        getOrganizations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    useEffect(() => {
        if (!isEmpty(organizations)) {
            setOrgTitle([]);
            // eslint-disable-next-line array-callback-return
            organizations.map(item => {
                // eslint-disable-next-line array-callback-return
                selected.map((sid: any) => {
                    if (item['id'] === sid) {
                        setOrgTitle(orgTitle => [...orgTitle, item['organization']]);
                    }
                });
            });
        };
    }, [selected, organizations]);

    const getItems = () => {
        if (!isEmpty(organizations)) {
            return organizations.map(item => <Item key={item['id']} {...{ item, selected, setSelected }} />);
        } else {
            return <span><Trans>Nothing found</Trans></span>
        }
    };

    const openPopov = (e: React.ChangeEvent<any>) => {
        setPopov(true);
        e.target.value = ''
    };

    const closePopov = () => {
        setPopov(false);
        store.setSpecInfo({ ...store.specInfo, "organizations": selected });
    };

    const onChange = (e: any) => {
        if (e.target.value.length > 1) {
            setQuery(e.target.value);
        }
    };

    const addOrganization = async () => {
        try {
            await UserService.createOrganization({ 'query': newOrg });
            setQuery('');
            getOrganizations();
        } catch (e) {
            console.log(e);
        };
    }

    return (
        <div className="form-group" style={{ position: "relative" }}>
            <div className="input-group">
                <div className="input-group-control w-100">
                    {popov ?
                        <input type="text" className="form-control"
                            defaultValue=''
                            placeholder={store.lang === 'ba' ? 'Табыр өсөн тексты индерә башлағыҙ' : store.lang === 'ru' ? 'Начните вводить текст, чтобы найти' : 'Start typing to find'}
                            autoComplete="off"
                            onChange={(e: React.ChangeEvent<any>) => onChange(e)} />
                        :
                        <input type="text" className="form-control" name='orgInput'
                            placeholder={store.lang === 'ba' ? 'Ойошманы һайлағыҙ' : store.lang === 'ru' ? 'Выберите организацию' : 'Choose an organization'}
                            value={orgTitle.join(', ')}
                            title={orgTitle.join(', ')}
                            readOnly
                            autoComplete="off"
                            onClick={(e: React.ChangeEvent<any>) => openPopov(e)}
                            onChange={() => { }} />
                    }
                </div>
            </div>
            {popov ?
                <div className="popov">
                    <div className="popov__title d-flex justify-content-between">
                        <div>
                            <button type='button' className='btn btn-light' value='' onClick={() => setOrgPopover(true)}><i className='icon add' /><Trans>Add a new organization to the list</Trans></button>
                        </div>
                        <div>
                            <input type='button' className='btn text-primary' value={store.lang === 'ba' ? 'Ябырға' : store.lang === 'ru' ? 'Закрыть' : 'Close'} onClick={() => { closePopov(); setOrgPopover(false); setQuery('') }} />
                        </div>
                    </div>
                    <div className="form-group">
                        {!orgPopover ?
                            getItems()
                            :
                            <div className="form-control">
                                <input type="text" className="form-control"
                                    placeholder={store.lang === 'ba' ? 'Ойошмағыҙҙың исемен индерегеҙ' : store.lang === 'ru' ? 'Введите название вашей организации' : 'Enter the name of your organization'}
                                    autoComplete="off"
                                    onChange={(e: React.ChangeEvent<any>) => setNewOrg(e.target.value)} />
                                <div className='text-center'>
                                    <input type='button'
                                        onClick={() => { addOrganization(); setOrgPopover(false) }}
                                        value={store.lang === 'ba' ? 'Өҫтәргә' : store.lang === 'ru' ? 'Добавить' : 'Add'}
                                        className="btn btn-gray m-1" />
                                    <input type='button'
                                        onClick={() => setOrgPopover(false)}
                                        value={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
                                        className="btn btn-gray m-1" />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                : null}
        </div>
    );
};